import { Theme } from '@constants';
export const LAYOUT_OFFSET = Theme.px(972);
